module.exports = __webpack_public_path__ + "assets/vehicle-connections.d3d7017d.svg";